
export default class AltImageElement extends HTMLElement {
    constructor(){
        super();
    }
}

customElements.define('alt-image', AltImageElement);